import { render, staticRenderFns } from "./EditPolygons.vue?vue&type=template&id=02f058e2&scoped=true&"
import script from "./EditPolygons.vue?vue&type=script&lang=js&"
export * from "./EditPolygons.vue?vue&type=script&lang=js&"
import style0 from "./EditPolygons.vue?vue&type=style&index=0&id=02f058e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f058e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VToolbar})
